/**
 * Utilitários para tradução de meses e formatação de datas
 */

// Mapeamento de meses inglês -> português (abreviados)
export const MESES_ABREV_EN_PT = {
  'Jan': 'Jan',
  'Feb': 'Fev',
  'Mar': 'Mar',
  'Apr': 'Abr',
  'May': 'Mai',
  'Jun': 'Jun',
  'Jul': 'Jul',
  'Aug': 'Ago',
  'Sep': 'Set',
  'Oct': 'Out',
  'Nov': 'Nov',
  'Dec': 'Dez'
};

// Meses completos em português (indexados de 1-12)
export const MESES_COMPLETOS = [
  '', 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

// Meses abreviados em português (indexados de 1-12)
export const MESES_ABREV = [
  '', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
  'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
];

/**
 * Traduz abreviação de mês de inglês para português
 * @param {string} mesEn - Mês em inglês (ex: "Apr")
 * @returns {string} - Mês em português (ex: "Abr")
 */
export const traduzirMes = (mesEn) => {
  if (!mesEn) return mesEn;
  return MESES_ABREV_EN_PT[mesEn] || mesEn;
};

/**
 * Traduz array de dados com campo de mês
 * @param {Array} dados - Array de objetos com campo 'mes'
 * @param {string} campoMes - Nome do campo de mês (default: 'mes')
 * @returns {Array} - Array com meses traduzidos
 */
export const traduzirMesesEmDados = (dados, campoMes = 'mes') => {
  if (!Array.isArray(dados)) {
    if (dados !== undefined && dados !== null) {
      console.warn('[traduzirMesesEmDados] esperava array, recebeu:', dados);
    }
    return [];
  }

  return dados.map(item => ({
    ...item,
    [campoMes]: traduzirMes(item?.[campoMes])
  }));
};

/**
 * Retorna label do período filtrado
 * @param {number} ano - Ano
 * @param {number|null} mes - Mês (1-12) ou null para todos
 * @returns {string} - Label formatado
 */
export const getLabelPeriodo = (ano, mes) => {
  if (mes && mes >= 1 && mes <= 12) {
    return `${MESES_COMPLETOS[mes]} ${ano}`;
  }
  return `Ano: ${ano}`;
};
